import _ from 'lodash';
import { ALTERNATE_REDIRECT_NOT_FOUND_MSG } from './errors';
import { logWarn } from './logging-utils';

/**
 * Returns alternate redirect data if an alternate redirect link is specified via query params.
 */
export default (req, marketplaceResponse) => {
  const alternateRedirectKey = _.get(req, 'query.alt');

  if (alternateRedirectKey) {
    const alternateRedirects = _.get(
      marketplaceResponse,
      'offer.internal_details.alternate_links.value',
      []
    );

    const altRedirect = _.find(alternateRedirects, {
      name: alternateRedirectKey,
    });

    if (!altRedirect) {
      logWarn(req, ALTERNATE_REDIRECT_NOT_FOUND_MSG, {
        alternateRedirectKey,
      });
    } else {
      return {
        destinationUrl: altRedirect.destination_url,
        partnerTrackingParam: altRedirect.tracking_parameter,
        monetizable: altRedirect.monetizable,
      };
    }
  }
  return null;
};
